module.exports = __webpack_public_path__ + "img/email-flow.2f19e6c8.png";